module.exports = __webpack_public_path__ + "static/media/user-1.3be6e975.jpg";